
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fzbVm", function(module, exports) {

$parcel$export(module.exports, "FooterCreateButtons", () => (parcelRequire("cEHmK")).FooterCreateButtons);

var $cEHmK = parcelRequire("cEHmK");

});
parcelRegister("cEHmK", function(module, exports) {

$parcel$export(module.exports, "FooterCreateButtons", () => $774b2680aae17aaf$export$ab00dd23925d8af0);
/**
 * @graphql cc
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $dIouf = parcelRequire("dIouf");

var $jmjWc = parcelRequire("jmjWc");

var $5xTWd = parcelRequire("5xTWd");

var $kDja4 = parcelRequire("kDja4");

var $2wo33 = parcelRequire("2wo33");
var $lfBMY = parcelRequire("lfBMY");

var $yuLaV = parcelRequire("yuLaV");

var $3zNFE = parcelRequire("3zNFE");

var $3e1an = parcelRequire("3e1an");

const $774b2680aae17aaf$var$ContentTreeOnboardingLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "45vJD",
    name: "ContentTreeOnboardingLoader",
    loader: async ()=>(await (parcelRequire("uEAGx"))).ContentTreeOnboarding
});

const $774b2680aae17aaf$var$TreeBottomCreateButtonLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wssRG",
    name: "TreeBottomCreateButtonLoader",
    loader: async ()=>(await (parcelRequire("8AULS"))).TreeBottomCreateButton
});
const $774b2680aae17aaf$export$ab00dd23925d8af0 = ({ spaceKey: spaceKey, isContentTreeLoading: isContentTreeLoading, emptyContent: emptyContent })=>{
    const isDatabasesGloballyEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const { isSpaceTypesCreationFlowEnabled: isSpaceTypesCreationFlowEnabled } = (0, $5xTWd.useCreateSpaceExperiment)();
    const { cohort: createFromContentTreeCohort, isCreateFromContentTreeEnrolled: isCreateFromContentTreeEnrolled, isCreateFromContentTreeEligible: isCreateFromContentTreeEligible } = (0, $3e1an.useCreateFromContentTreeEligible)();
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $3zNFE.FooterCreateButtonsQuery), {
        errorPolicy: 'all',
        variables: {
            spaceKey: spaceKey
        }
    });
    if (isContentTreeLoading || loading || !data) return null;
    const canCreatePage = (0, $2wo33.canPerformSpaceOperation)({
        operationCheckResult: data,
        operation: (0, $lfBMY.OperationTypes).CREATE,
        contentType: 'page'
    });
    if (!canCreatePage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, emptyContent);
    const didContainUserContent = data?.space?.didContainUserContent;
    const showContentTreeOnboarding = isSpaceTypesCreationFlowEnabled && didContainUserContent === false;
    const showLiveDoc = Boolean(data?.space?.spaceTypeSettings?.enabledContentTypes?.isLivePagesEnabled);
    const showWhiteboard = isWhiteboardFeatureEnabled('whiteboardsEnabled') && Boolean(data?.space?.spaceTypeSettings?.enabledContentTypes?.isWhiteboardsEnabled);
    const showDatabase = isDatabasesGloballyEnabled && Boolean(data?.space?.spaceTypeSettings?.enabledContentTypes?.isDatabasesEnabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, showContentTreeOnboarding ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($774b2680aae17aaf$var$ContentTreeOnboardingLoader, {
        showLiveDoc: showLiveDoc,
        showWhiteboard: showWhiteboard,
        showDatabase: showDatabase
    }) : emptyContent || isCreateFromContentTreeEnrolled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($774b2680aae17aaf$var$TreeBottomCreateButtonLoader, {
        cohort: createFromContentTreeCohort,
        isCreateFromContentTreeEligible: isCreateFromContentTreeEligible,
        spaceKey: spaceKey,
        source: "endOfContentTreeContextualCreate"
    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }));
};

});
parcelRegister("5xTWd", function(module, exports) {

$parcel$export(module.exports, "useCreateSpaceExperiment", () => $c339f8d667855dc1$export$718c8063156c26da);

var $9wGTI = parcelRequire("9wGTI");

var $gTyTP = parcelRequire("gTyTP");
const $c339f8d667855dc1$export$718c8063156c26da = ()=>{
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const isSpaceTypesCreationFlowEnabled = isLivePagesFeatureEnabled || (0, $9wGTI.fg)('space_types_creation_flow');
    return {
        isSpaceTypesCreationFlowEnabled: isSpaceTypesCreationFlowEnabled
    };
};

});

parcelRegister("3zNFE", function(module, exports) {

$parcel$export(module.exports, "FooterCreateButtonsQuery", () => $b715d80530d9857d$export$7376118bf2f7661d);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $b715d80530d9857d$export$7376118bf2f7661d = (0, $d2LG0.default)`query FooterCreateButtonsQuery($spaceKey:String){space(key:$spaceKey){id key spaceTypeSettings{enabledContentTypes{isLivePagesEnabled isWhiteboardsEnabled isDatabasesEnabled}}didContainUserContent id operations{operation targetType}}}`;

});

parcelRegister("3e1an", function(module, exports) {

$parcel$export(module.exports, "CREATE_FROM_CONTENT_TREE_EXPERIMENT", () => $b56291077b70d291$export$f79e2fa2c6eaeb9d);
$parcel$export(module.exports, "useCreateFromContentTreeEligible", () => $b56291077b70d291$export$e3311b0f2b98cfd1);

var $6mKj3 = parcelRequire("6mKj3");
var $b56291077b70d291$export$cbca10bbfe25becd = /*#__PURE__*/ function(CreateFromContentTreeCohorts) {
    CreateFromContentTreeCohorts["NOT_ENROLLED"] = "not-enrolled";
    CreateFromContentTreeCohorts["CONTROL"] = "control";
    CreateFromContentTreeCohorts["TEST"] = "test";
    return CreateFromContentTreeCohorts;
}({});
const $b56291077b70d291$export$f79e2fa2c6eaeb9d = 'confluence_create_from_content_tree_experiment';
const $b56291077b70d291$export$e3311b0f2b98cfd1 = ()=>{
    const [expConfig] = (0, $6mKj3.UNSAFE_noExposureExp)('confluence_create_from_content_tree_experiment');
    const cohort = expConfig.get('cohort', "not-enrolled");
    const isCreateFromContentTreeEnrolled = cohort !== "not-enrolled";
    const isCreateFromContentTreeEligible = cohort === "test";
    return {
        cohort: cohort,
        isCreateFromContentTreeEnrolled: isCreateFromContentTreeEnrolled,
        isCreateFromContentTreeEligible: isCreateFromContentTreeEligible
    };
};

});

parcelRegister("uEAGx", function(module, exports) {

let $05c249ec49b6287c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $05c249ec49b6287c$var$load("juVlo"),
    $05c249ec49b6287c$var$load("joJy8"),
    $05c249ec49b6287c$var$load("aHE9G"),
    $05c249ec49b6287c$var$load("ffEVr"),
    $05c249ec49b6287c$var$load("67Pvd")
]).then(()=>parcelRequire('6IU81'));

});

parcelRegister("8AULS", function(module, exports) {

let $641db91844038e36$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $641db91844038e36$var$load("c0kqt"),
    $641db91844038e36$var$load("juVlo"),
    $641db91844038e36$var$load("ffEVr"),
    $641db91844038e36$var$load("joJy8"),
    $641db91844038e36$var$load("aHE9G"),
    $641db91844038e36$var$load("d1QkY")
]).then(()=>parcelRequire('hydSe'));

});



parcelRegister("5rZJf", function(module, exports) {

$parcel$export(module.exports, "SpaceOperationsQuery", () => $8e7057c5d2ae7999$export$636a01496687d185);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $d2LG0.default)`query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id operations{operation targetType}}}`;

});


//# sourceMappingURL=FooterCreateButtons.0aee01de.js.map
